(function () {
    'use strict';

    angular.module("imApp").factory("modelLangsService", ['$ihttp', function ($ihttp) {
        let service = {
            listModelLanguages: function (parms) {
                return $ihttp.post({
                    method: 1165,
                    parameters: parms || {}
                });
            },
            saveObj: function (list) {
                return $ihttp.post({
                    method: 1166,
                    parameters: list
                });
            }
        };

        return service;
    }]);
})();
